import { render, staticRenderFns } from "./SendMessages.vue?vue&type=template&id=3d8ea0a0"
import script from "./SendMessages.vue?vue&type=script&lang=js"
export * from "./SendMessages.vue?vue&type=script&lang=js"
import style0 from "./SendMessages.vue?vue&type=style&index=0&id=3d8ea0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports